var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"asc-legend-list-item"},[_c('div',{class:[
      'asc-legend-list-item--content',
      _vm.isSelected ? 'asc-legend-list-item--disabled' : null ],on:{"click":_vm.handleItemClick}},[_c('div',{staticClass:"asc-legend-list-item--flex"},[_c('div',{staticClass:"asc-legend-list-item--icon",style:({
          'background-color': _vm.styleColor,
          height: '12px',
          width: '12px',
          'border-radius': _vm.borderRadius,
          border: _vm.border,
        })}),_c('div',{class:[
          'asc-legend-list-item--text',
          _vm.filter ? 'asc-legend-list-item--text-hover' : '' ]},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }